<template>
  <base-share-button @click="click">
    <template #icon>
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="25" cy="25" r="25" fill="#BAF5B4" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.0874 18.1113C20.816 17.4612 20.6101 17.4365 20.1989 17.4199C20.0589 17.4118 19.9029 17.4037 19.7299 17.4037C19.1948 17.4037 18.6355 17.5601 18.2979 17.9057C17.8867 18.3255 16.8662 19.3048 16.8662 21.313C16.8662 23.3213 18.3307 25.2636 18.5283 25.5355C18.7341 25.8067 21.3836 29.9879 25.4977 31.692C28.7148 33.0253 29.6694 32.9017 30.4016 32.7455C31.4713 32.5152 32.8124 31.7246 33.15 30.7702C33.4873 29.8153 33.4873 29.0005 33.3884 28.8277C33.2897 28.6549 33.0181 28.5564 32.6068 28.3504C32.1956 28.1445 30.196 27.1569 29.8175 27.0252C29.4472 26.8854 29.0935 26.9348 28.8139 27.3299C28.4188 27.8814 28.0323 28.4412 27.7195 28.7785C27.4727 29.0418 27.0694 29.0749 26.7321 28.9349C26.2795 28.7459 25.0125 28.3009 23.4491 26.9101C22.2394 25.8321 21.4167 24.4907 21.1782 24.0874C20.9396 23.6759 21.1535 23.437 21.3427 23.215C21.5486 22.9597 21.7459 22.7788 21.9515 22.5399C22.1573 22.3013 22.2724 22.1779 22.4041 21.8979C22.5441 21.6264 22.4452 21.3464 22.3466 21.1406C22.2477 20.9343 21.425 18.926 21.0874 18.1113ZM24.9958 11C17.2779 11 11 17.2797 11 24.9998C11 28.0614 11.9874 30.901 13.6659 33.2055L11.9214 38.4072L17.3026 36.6874C19.5159 38.1523 22.1571 39 25.0042 39C32.7221 39 39 32.7199 39 25.0002C39 17.2801 32.7221 11.0004 25.0042 11.0004H24.9961V11H24.9958Z"
          fill="#F4FAFD"
        />
      </svg>
    </template>
    <template #title>
      {{ $t('social-share-buttons.whatsapp') }}
    </template>
  </base-share-button>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import BaseShareButton from '@vue-app/components/base/share/buttons/BaseShareButton.vue'

export default {
  name: 'WhatsAppShareButton',
  components: { BaseShareButton },
  methods: {
    click() {
      $emit(this, 'share', 'whatsapp')
    },
  },
  emits: ['share'],
}
</script>
